import React, { FC } from 'react'

import Spinner from '../../components/common/spinner/Spinner'
import UserDetail from '../../components/common/user/user-detail/UserDetail'
import './UserCreationInfo.less'
import { UserCreationMethodEnum } from '../../../../types/User'
import { useUserCreationInfoQuery } from './UserCreationInfo.codegen'
import { Trans } from '@lingui/macro'
import { NbSp } from 'front-end/src/utils/NbSp'

import { formatDateAndTimeShort } from 'front-end/src/utils/dateHelpers'

const getCreationMethodLabel = (method: UserCreationMethodEnum) => {
  switch (method) {
    case UserCreationMethodEnum.SELF_SIGNUP:
      return (
        <Trans>
          <NbSp />
          through
          <NbSp />
          <strong>self signup</strong>
        </Trans>
      )
    case UserCreationMethodEnum.SCIM:
      return (
        <>
          <NbSp />
          <Trans>through</Trans>
          <NbSp />
          <strong>SCIM</strong>
        </>
      )
    case UserCreationMethodEnum.FOURTH_SCIM:
      return (
        <>
          <NbSp />
          <Trans>through</Trans>
          <NbSp />
          <strong>Fourth SCIM</strong>
        </>
      )
    case UserCreationMethodEnum.BAMBOOHR_SCIM:
      return (
        <>
          <NbSp />
          <Trans>through</Trans>
          <NbSp />
          <strong>BambooHR SCIM</strong>
        </>
      )
    case UserCreationMethodEnum.MANUAL:
      return (
        <>
          <NbSp />
          <strong>
            <Trans>manually</Trans>
          </strong>
        </>
      )
    case UserCreationMethodEnum.SSO_JIT:
      return (
        <Trans>
          <NbSp />
          through
          <NbSp />
          <strong>SSO just-in-time provisioning</strong>
        </Trans>
      )
    case UserCreationMethodEnum.CSV_IMPORT:
      return (
        <Trans>
          <NbSp />
          via
          <NbSp />
          <strong>CSV import</strong>
        </Trans>
      )
    case UserCreationMethodEnum.SECRET_SIGNUP_LINK:
      return (
        <Trans>
          <NbSp />
          via
          <NbSp />
          <strong>secret signup link</strong>
        </Trans>
      )
    default:
      const exhaustiveCheck: never = method
      throw new Error(`Unhandled case: ${exhaustiveCheck}`)
  }
}

export const UserCreationInfo: FC<{
  userId: number
}> = ({ userId }) => {
  const { data, loading } = useUserCreationInfoQuery({
    variables: {
      userId
    }
  })
  if (loading) {
    return <Spinner />
  }
  if (!data?.admin?.user) {
    return null
  }
  const { user } = data?.admin

  return (
    <div className="UserCreationInfo">
      <span>
        <Trans>Created</Trans>
        {formatDateAndTimeShort(user.created_at)}
      </span>
      {user?.createdBy && (
        <>
          <NbSp />
          <Trans>by</Trans> <UserDetail {...(user?.createdBy as any)} />
        </>
      )}
      {user!.creation_method
        ? getCreationMethodLabel(user.creation_method)
        : null}
    </div>
  )
}
